import cacheApi from '@/core/cacheApi'

import { handleError } from '@/helpers/handleError'
import type { ApiErrorResponse, ApiResponse } from '@/types/apiResponse'

export async function getAllOrders(): Promise<ApiResponse> {
  try {
    const {
      data,
      status: _status,
      headers
    } = await cacheApi.get(`/wp-json/wc/v3/orders`, {
      params: {
        status: 'new,processing',
        per_page: 100
      }
    })

    return {
      success: true,
      data: {
        orders: data,
        total_items: parseInt(headers['x-wp-total'])
      }
    }
  } catch (error: any) {
    handleError(error)
    return {
      success: false,
      error: error as ApiErrorResponse
    }
  }
}
